import { useEffect, Dispatch } from 'react';
import { ProductoData, TipoProducto } from '../../model/ProductoData';
import { CanjeAction } from './useCanjeStatus';

/**
 * Hook que se utiliza para detectar si el producto a
 * canjear tiene un tipo de producto correcto.
 * Para que el tipo de producto sea correcto, debe
 * estar definido en algunos de los valores registrados
 * en el enum TipoProducto.
 * @param product: datos del producto provenientes del
 * backend.
 * @param dispatch: función para actualizar el estado
 * general en el proceso de canje.
 */
export const useValidateProductType = (product: ProductoData | undefined, dispatch: Dispatch<CanjeAction> | undefined) => {
  useEffect(() => {
    if (product == null || dispatch == null) return;
    if (product.tipoProducto == null || !checkProductType(product.tipoProducto)) dispatch(CanjeAction.ERROR);
  }, [product, dispatch]);
};

export const checkProductType = (prodType: TipoProducto | undefined): boolean => {
  if (!prodType) return false;
  return Object.values(TipoProducto).includes(prodType);
};
